// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style.scss
// module id = 2
// module chunks = 0